import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
  Chip,
  Grid,
} from "@mui/material";
import {
  CalendarToday,
  LocationOn,
} from "@mui/icons-material";
import tagImage from "../../Images/tag.png";
import moment from "moment";

const MyEventsSavedEventsView = ({ events }) => {
  return (
    <Grid container spacing={3}>
      {events?.map((event, index) => {
        const daysLeft = moment(event.event_start_date).diff(moment(), "days");
        return (
          <Grid item xs={12} md={6} key={index}>
            <Card
              elevation={0}
              sx={{
                borderRadius: 5,
                border: "1px solid #e0e0e0",
                position: "relative",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  
                  backgroundImage: `url(${tagImage})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  fontSize: "10px",
                  color: "white",
                  py: 0.5,
                  px: 2,
                  borderTopRightRadius: 12,
                  borderBottomLeftRadius: 12,
                }}
              >
                <Typography
                  sx={{ paddingLeft: 1 }}
                  variant="body2"
                  fontWeight="medium"
                >
                  {daysLeft > 0 && `${daysLeft} days left`}
                </Typography>
              </Box>
              <CardContent sx={{ p: 3 }}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="flex-start"
                  mb={2}
                >
                  <Typography variant="h5" fontWeight="bold">
                    {event.event_name}
                  </Typography>
                </Box>

                <Stack spacing={1} mb={3}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <CalendarToday sx={{ color: "#666" }} />
                    <Typography color="#666">
                      {moment(event.event_start_date).format("MMM DD, YYYY")}
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" gap={1}>
                    <LocationOn sx={{ color: "#666" }} />
                    <Typography color="#666">{event.event_address}</Typography>
                    <Typography color="#666">{event.city}</Typography>
                    <Typography color="#666">{event.country}</Typography>
                  </Box>
                </Stack>

                <Button
                  variant="text"
                  color="primary"
                  sx={{
                    bgcolor: "transparent",
                    textTransform: "none",
                    color: "#6EBC7B",
                    "&:hover": {
                      bgcolor: "transparent",
                      textDecoration: "underline",
                    },
                  }}
                >
                  Go to shop
                </Button>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default MyEventsSavedEventsView;
